let phone = {};

phone = require('../data/phone')

module.exports = phone;